const unCheckPermissions = [
    { id: 0, name: 'home', pageUrl: '/app/home', menuLabel: 'home', parentId: -1, type: 'menu' },
    // { id: 1, name: 'cardStatusManagement', pageUrl: '/app/card-status-management', menuLabel: 'cardStatusManagement', parentId: -1, type: 'menu' },
    // { id: 2, name: 'cardStatusManagement', pageUrl: '/app/card-status-management/view-list', menuLabel: 'cardStatusManagement', parentId: 1, type: 'menu' },
    // { id: 3, name: 'cardStatusManagement', pageUrl: '/app/card-status-management/file-import-logs', menuLabel: 'cardStatusManagement', parentId: 1, type: 'menu' },
    // { id: 4, name: 'cardStatusManagement', pageUrl: '/app/card-status-management/file-import-audit-logs', menuLabel: 'cardStatusManagement', parentId: 1, type: 'menu' },
];

export const permissionsHelper = (user) => {
    if (!user) return unCheckPermissions;
    return [...unCheckPermissions, ...user?.permissions];
};